import { Autocomplete, InputSize, InputText, SelectSize } from '@ui/src';
import { Controller } from 'react-hook-form';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { CountryAndNameTypes } from './types';

import commonStyles from '../../common/styles.module.css';

const CountryAndName = ({
  control,
  countries,
  errors,
  status,
  clearErrors,
  isEditable,
  regulatedCompanyScheme,
  questionnarieClearErrors,
  questionnarieControl,
  questionnarieErrors,
}: CountryAndNameTypes) => (
  <StepPartBlock title="Country and Name">
    <>
      <InfoRow
        title="Country of incorporation of the company"
        id="countryOfIncorporationId"
        lessPadding
      >
        <Controller
          control={control}
          name="countryOfIncorporationId"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              name="countryOfIncorporationId"
              placeholder="Select country..."
              list={countries}
              value={value}
              error={errors?.countryOfIncorporationId?.message}
              className={`${commonStyles.newApplicationAutocomplete} ${
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED
                  ? commonStyles.newApplicationAutocompleteDisabled
                  : ''
              }`}
              size={SelectSize.SMALL}
              onChange={(e) => {
                onChange(e);

                clearErrors(['countryOfIncorporationId']);
              }}
              tabIndex={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              disabled={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
              borderless
              fullWidth
            />
          )}
        />
      </InfoRow>
      <InfoRow title="Company name" id="companyName" lessPadding>
        <Controller
          control={control}
          name="companyName"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name="companyName"
              placeholder="Enter company name..."
              value={value}
              onChange={(e) => {
                onChange(e);

                clearErrors(['companyName']);
              }}
              size={InputSize.SMALL}
              className="borderless"
              error={errors?.companyName?.message}
              tabIndex={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
            />
          )}
        />
      </InfoRow>
      {regulatedCompanyScheme && (
        <InfoRow title="Trading name (optional)" id="tradingName" lessPadding>
          <Controller
            control={questionnarieControl}
            name="tradingName"
            defaultValue=""
            render={({ field: { onChange, value, name } }) => (
              <InputText
                name={name}
                placeholder="Enter trading name..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['tradingName']);
                }}
                size={InputSize.SMALL}
                className="borderless"
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                error={questionnarieErrors?.tradingName?.message}
              />
            )}
          />
        </InfoRow>
      )}
    </>
  </StepPartBlock>
);

export default CountryAndName;
